module.exports = __webpack_public_path__ + "static/media/badgeOff_326.bb24c45f.png";